const N_WORKERS = 2

class ImagePrecache {
	constructor() {
		this.running = false
		this.queue = []
		this.workers = []
		this.n = 0
		//this.nl = 0
		//this.loaded = []
		//this.started = 0
		//this.cached = 0
		//this.ncached = 0
	}
	
	afterPreload = (img, w, cached) => {
		img.cb(w.img.width, w.img.height, cached)
		//this.nl += 1
		//console.log('loaded '+this.nl)
		
		//this.loaded.forEach(f => {if(f===img.src) {console.log('DOUBLE')}})
		//this.loaded.push(img.src)
		//console.log('free')
		this.workers[w.i].free = true
		setTimeout(()=>{this.realPreload()})
		//this.realPreload()
	}

	preloadImage = (img, w) => {
		let cached = false
		w.img.onload = () => {
			if(cached) return
			//this.ncached += 1
			//console.log('cached:'+this.cached + ', ncached:'+this.ncached)
			this.afterPreload(img, w, false)
		}
		w.img.onerror = () => {
			//console.log('error loading '+img.src)
			this.workers[w.i].free = true
			setTimeout(()=>{this.realPreload()})
		}
		if(img.th) w.img.src = 'data:image/jpeg;charset=utf-8;base64, ' + img.src
		else w.img.src = img.src
		if(w.img.complete) {
			cached = true
			//this.cached += 1
			//console.log('cached:'+this.cached + ', ncached:'+this.ncached)
			this.afterPreload(img, w, true)
		}
	}

	realPreload = () => {
		if(this.queue.length===0) {
			this.running = false
			//console.log('loaded '+this.n)
			//console.log(this.workers.length)
			//setTimeout(()=>{this.realPreload()}, 1000)
			return
		}
	
		while(this.queue.length>0) {
			const freeWorkers = this.workers.filter(w => w.free)
			if (freeWorkers.length===0) {
				if (this.workers.length<N_WORKERS) {
					const w = {
						img: new Image(),
						free: false,
						i: this.workers.length
					}
					this.workers.push(w)
					const img = this.queue.shift()
				//this.started += 1
				//console.log('start '+this.started + ' ' + img.src)
					setTimeout(()=>{this.preloadImage(img, w)})
					//this.preloadImage(img, w)
				} else {
					return
				}
			} else {
				let w = freeWorkers[0]
				this.workers[w.i].free = false
				const img = this.queue.shift()
				//this.started += 1
				//console.log('start '+this.started + ' ' + img.src)
				setTimeout(()=>{this.preloadImage(img, w)})
				//this.preloadImage(img, w)
			}
		}
	}
	
	preload = (src, th, cb) => {
		this.n += 1
		this.queue.push({src, th, cb})
		//console.log(this.n + ': ' + src)
		if(this.running) return
		this.running = true
		this.realPreload()
	}
}
const imagePrecache = new ImagePrecache()

export default imagePrecache


// WEBPACK FOOTER //
// ./src/fm/lib/ImagePrecache.js